<div fxFill fxLayout="column" class="legacy-md-content scrollable dashboard">
    @if (timeElapsed) {
    <forge-banner theme="success" class="refresh">
        <forge-icon slot="icon" name="refresh"></forge-icon>
        <div>Click Refresh to get the latest Dashboard data.</div>
        <forge-button slot="button" variant="outlined" (click)="refresh()">
            Refresh...
        </forge-button>
    </forge-banner>
    }
    <forge-toolbar>
        <h1 class="forge-typography--heading4" slot="start">My Dashboard</h1>
        @if (chartsLoaded) {
        <forge-icon-button slot="end" (click)="displayChartOrdering()" aria-label="Dashboard settings" tabindex="0"
            aria-haspopup="true">
            <forge-tooltip>Dashboard settings</forge-tooltip>
            <forge-icon name="settings"></forge-icon>
        </forge-icon-button>
        }
    </forge-toolbar>
    <div fxLayout="row" fxLayoutGap="20px">
        <!-- TODO - removed unknown attribute; was: 'hide-tablet' -->
        <div fxFlex="5" fxHide fxShow.gt-md></div>
        <div fxFlex.gt-md="90" fxFlex.lt-lg="100" fxLayout="column" fxLayoutAlign="space-between">
            <widget-bar fxFlex="100%"></widget-bar>
            <processes-component [enableLink]="embedded" fxHide.lt-md></processes-component>
            <div fxFill fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between">
                <div fxFlex.gt-sm="50" fxLayout="column" class="inline-block" style="margin-top: 16px;">
                    <tasks-list header="Smart Cards"></tasks-list>
                    @if (aggregateChartsLoaded) {
                    <div class="block">
                        @for (chartAggregate of getChartAggregates(0); track trackByAggregateId($index, chartAggregate))
                        {
                        <div class="show-overflow">
                            <aggregate-chart [aggregate]="chartAggregate">
                            </aggregate-chart>
                        </div>
                        }
                    </div>
                    }
                    @if (chartsLoaded) {
                    <div class="block">
                        @for (chartCriteria of leftCharts; track trackByChartId($index, chartCriteria)) {
                        <div>
                            <dashboard-chart [chartCriteria]="chartCriteria"></dashboard-chart>
                        </div>
                        }
                    </div>
                    }
                </div>
                <div fxFlex.gt-sm="50" fxLayout="column" class="block">
                    <dashboard-metadata layout-fill layout-align="start center"></dashboard-metadata>
                    <email-test-card>
                    </email-test-card>
                    <user-lookup-card>
                    </user-lookup-card>
                    @if (showEmployeeLookup) {
                    <employee-lookup-card>
                    </employee-lookup-card>
                    }
                    @if (aggregateChartsLoaded) {
                    <div class="block">
                        @for (chartAggregate of getChartAggregates(1); track trackByAggregateId($index, chartAggregate))
                        {
                        <div>
                            <aggregate-chart [aggregate]="chartAggregate">
                            </aggregate-chart>
                        </div>
                        }
                    </div>
                    }
                    @if (chartsLoaded) {
                    <div class="block">
                        @for (chartCriteria of rightCharts; track trackByChartId($index, chartCriteria)) {
                        <div>
                            <dashboard-chart [chartCriteria]="chartCriteria"></dashboard-chart>
                        </div>
                        }
                    </div>
                    }
                </div>
            </div>
        </div>
        @if (isProcessing) {
        <busy-indicator [page]="true"></busy-indicator>
        }
    </div>
</div>


<ng-template #ieWarning>

    <mat-dialog-content class="browser-dialog">
        <div>
            <img src="https://cdn.forge.tylertech.com/v1/images/spot-hero/unsupported-browser-error-spot-hero.svg"
                alt="Illustration of an outdated computer.">
        </div>

        <div style="margin-top: 64px;">
            <h2>Vintage is cool, but it's time for an upgrade.</h2>
        </div>

        <div style="height:100%">
            For the best user experience, we recommend a modern browser (Chrome, FireFox, Safari or
            Edge)
        </div>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button mat-button matDialogClose telemetry="Submission-Dismiss">
            Dismiss
        </button>
    </mat-dialog-actions>
</ng-template>